<script>
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import Divider from "@/components/atoms/divider";
import Container from "@/components/atoms/container";
import LinkTo from "@/components/atoms/link-to";
import Button from "@/components/atoms/button";
export default {
  name: "SeoContent",
  components: { HtmlParser, Divider, Container, LinkTo, Button },
  props: {
    liens: {
      type: Object,
      required: false,
      default: null
    },
    rayons: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    }
  }
};
</script>
<template>
  <Container>
    <Divider
      v-if="liens && liens.html_content"
      dotted
      size="sm"
      class="u-my-md"
    />
    <HtmlParser
      v-if="liens && liens.html_content"
      context="HP SEO LIENS"
      class="c-cms-container__content"
      :content="liens.html_content"
    />
    <Divider
      v-if="rayons && rayons.html_content"
      dotted
      size="sm"
      class="u-my-md"
    />
    <HtmlParser
      v-if="rayons && rayons.html_content"
      context="HP SEO RAYONS"
      class="c-cms-container__content"
      :content="rayons.html_content"
    />
  </Container>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/globals/cms.scss";
/*
* Voir plus
*/
.c-seo-content__show-partially {
  position: relative;
  overflow: hidden;
  max-height: 17rem;
  position: relative;
  @include mq(bp(sm)) {
    max-height: 12rem;
  }
  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 10rem;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(246, 246, 246, 1) 100%
    );
    @include mq(bp(sm)) {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  }
}
</style>